import type { DataProvider } from "ra-core";
import type { Task } from "../types";

/** Supabase caps individual responses; never request an unbounded 10,000-row page. */
export async function getCalendarTasks(
  provider: Pick<DataProvider, "getList">,
  filter: Record<string, unknown>,
  signal?: AbortSignal,
) {
  const result: Task[] = [];
  const seen = new Set<string>();
  for (let page = 1; ; page++) {
    signal?.throwIfAborted();
    const response = await provider.getList<Task>("tasks", {
      pagination: { page, perPage: 500 },
      sort: { field: "id", order: "ASC" },
      filter,
      signal,
    });
    let added = 0;
    for (const task of response.data)
      if (!seen.has(String(task.id))) {
        seen.add(String(task.id));
        result.push(task);
        added++;
      }
    const more =
      response.total != null
        ? result.length < response.total
        : (response.pageInfo?.hasNextPage ?? response.data.length === 500);
    if (!more) return result;
    if (!added)
      throw new Error(
        "Не удалось загрузить все события календаря. Обновите страницу.",
      );
  }
}
